// extracted by extract-css-chunks-webpack-plugin
module.exports = {"embed_loading":"Embed__embed_loading--3WvcR"};